import { UPDATE_LOCALE } from '../constants/ActionTypes';
import esMessages from '../lang/esMessages';
import moment from 'moment';

const defaultStore = {
  lang: 'es',
  messages: esMessages
};

const locale = (state = defaultStore, action) => {
  switch (action.type) {
    // Update Locale call
    case UPDATE_LOCALE:
      moment.locale(action.payload.lang);
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

module.exports = locale;



// WEBPACK FOOTER //
// ./reducers/localeReducer.js